export const NATIVE_EVENTS = {
  GAME_COMPLETED: 'GAME_COMPLETED',
  GAME_UNAUTHORIZED: 'GAME_UNAUTHORIZED',
} as const;
